<!-- Loader si isLoading est true -->
<div *ngIf="isLoading" class="fixed inset-0 flex items-center justify-center bg-white z-50">
  <mat-spinner diameter="50"></mat-spinner>
</div>

<!-- isLoading est false on peut passer sur l'ecran classique -->
<div *ngIf="!isLoading"
     class="relative flex flex-col min-h-screen font-poppins bg-[url('/assets/img/waiting-notes/bg_banner2.png')] bg-cover bg-center text-gray-900">
  <!-- Overlay gris transparent -->
  <div class="absolute inset-0 bg-black/20 pointer-events-none z-0"></div>

  <!-- Contenu -->
  <!-- <div class="relative z-10 h-screen flex flex-col mx-auto sm:w-[600px]"> -->
  <div class="relative z-10 h-screen flex flex-col mx-auto sm:w-[600px]">

    <!-- section top -->
    <div class="h-[40vh] w-full">

      <!-- toolbar -->
      <div class="flex flex-row justify-between p-2.5">

        <div class="flex flex-row justify-end gap-2.5">

          <!-- Bouton Home en haut à droite -->
          <button routerLink="/home" class="bg-white shadow rounded-full w-10 h-10 flex items-center justify-center">
            <mat-icon class="text-gray-500 hover:text-primary">home</mat-icon>
          </button>

        </div>

        <!-- Logo -->
        <div class="flex justify-center mx-auto max-w-2xl">
          <img src="assets/img/waiting-notes/logo.png" alt="Logo" class="w-24 h-24 rounded-full mb-2 object-cover">
        </div>

        <div class="flex flex-row justify-end gap-2.5">

          <!-- Bouton historique des paiements -->
          <button (click)="openPaymentHistoryDialog()"
                  class="bg-white shadow rounded-full w-10 h-10 flex items-center justify-center">
            <mat-icon class="text-gray-500 hover:text-primary">schedule</mat-icon>
          </button>

        </div>

      </div>

      <!-- entête -->
      <div *ngIf="pointOfSale" class="bg-white mx-4 p-4 shadow rounded-2xl max-w-2xl flex flex-col items-center">
        <h1 class="font-bold text-center mb-2 text-2xl text-primary">
          {{ pointOfSale.name }}
        </h1>
        <p class="text-sm text-center text-gray-600 mb-6">
          {{ pointOfSale.address }}<br>
          {{ pointOfSale.postal }} {{ pointOfSale.city }}<br>
          Tel : {{ pointOfSale.phone }}
        </p>
      </div>

      <!-- Infos additionnelles -->
      <div class="text-xs text-gray-700 mx-4 mt-4 bg-white p-2 rounded-2xl flex justify-between max-w-2xl">
        <span><strong>Date :</strong> {{ today | date: 'dd/MM/yyyy HH:mm' }}</span>
        <span><strong>Table :</strong> {{ tableNumber }}</span>
        <span><strong>Note n° :</strong> {{ firstNote?.r_note || '...' }}</span>
      </div>

    </div>

    <!-- Liste des items -->
    <div class="h-[60vh] mx-4 max-w-2xl flex flex-col justify-center p-2 bg-white rounded-t-2xl">

      <div class="p-2.5">
        <h3 class="text-right font-bold mt-4 pr-4">Total : {{ totalBrut | number: currencyDecimals }} {{ currencySymbol
          }}</h3>
        <h2 class="text-right font-bold mb-4 pr-4">Reste à payer : {{ totalBrut - (paidAmount - calculateTotalTips()) |
          number: currencyDecimals }} {{ currencySymbol }}</h2>
      </div>

      <div class=" w-full max-w-2xl mx-auto p-2 overflow-y-auto flex-1">
        <app-item-line *ngFor="let item of structuredItems" [item]="item"></app-item-line>
      </div>

      <!-- Boutons d'action -->
      <div class="  mx-auto max-w-2xl w-full p-2 flex justify-center">
        <div *ngIf="!showPaymentOptions; else paymentOptions" class="mx-auto max-w-2xl w-full">
          <button (click)="showPaymentOptions = true"
                  class="w-full text-white font-bold text-lg py-4 bg-[#4d47dc] shadow-md rounded-full">
            Payer
          </button>
        </div>
        <ng-template #paymentOptions>
          <div class="mx-auto max-w-2xl w-full space-y-2">
            <button (click)="startPaymentFlow('options')"
                    class="bg-white w-full font-bold text-lg py-4 shadow-md rounded-full">
              Autres choix
            </button>
            <button (click)="startPaymentFlow('full')"
                    class="w-full text-white font-bold text-lg py-4 bg-[#4d47dc] shadow-md rounded-full">
              Payer la totalité ({{ getSelectedTotals().maxTotal | number:'1.2-2' }} €)
            </button>
          </div>
        </ng-template>
      </div>

    </div>
  </div>
</div>
